import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
  Snackbar,
  Alert,
  Breadcrumbs
} from '@mui/material';
import {
  keywordOverviewCss,
  KeywordOverviewTableCss,
  snackBar
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import { GMBTutorialLinks, localSeoTexts } from './localSeoTexts';
import { lazy, useEffect, useMemo, useRef, useState } from 'react';
import { CreateNewPostCss, LocalSeoAllSx } from './localSeoCss';
import { ListDataTableCss } from '../keywordResearch/keywordsLists/KeywordListsCss';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsAgencyUpgrade, setLocalSeoSection } from 'src/redux/keywordResearch';
import { RootState } from 'src/redux/store';
import {
  getCreditDetails,
  getLocations,
  gmpPostList
} from 'src/common/Scraper';
import {
  setBusinessNamesData,
  setGmpListData,
  setGoogleListingTitle,
  setIsConnectionFlow,
  setLocalPostNameId,
  setLocalPostStatus,
  setLocationListResponse,
  setLocationsDetailsLoader,
  setReduxFilteredLocationsData,
  setReduxLocationsData,
  setSelectedAccountId,
  setSelectedBusinessAccountId,
  setSelectedBusinessName,
  setSelectedBusinessNameFilter,
  setSelectedLocationId,
  setUpdatePostLoader
} from 'src/redux/localSeo';
import { BackLinkAllCss } from '../OtherTools/BackLinkCss';
import {
  enterpriseDropdownBusinessesLimit,
  keywordOverviewTexts,
  localSeoSignupSourceSqsp,
  localseoSignupSqspFlow,
  paths,
  SEOSpaceLocal
} from 'src/common/config/TextMessage';
import {
  getCookie,
  isLocalSeoUser,
  localStorageMethod,
  openNewTab
} from 'src/common/config/FunctionHelper';
import { useNavigate } from 'react-router';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Helmet } from 'react-helmet-async';
import { KeywordTrackingAllTexts } from '../keywordResearch/keywordTracking/KeywordTrackingAllTexts';
import {
  getLocalSeoBusinessId,
  getLocalSeoId,
  setLocalSeoBusinessId,
  setLocalSeoId,
  updateSearchesDetailsAndLimits
} from 'src/common/config/FunctionHelperPartTwo';
import { useChromeBrowserBanner } from 'src/hooks/useChromeBrowserBanner';
import { useBrowserType } from 'src/hooks/useBrowserType';
import Loader from 'src/common/config/Loader';
// Named Exports
const PostingRow = Loader(
  lazy(() =>
    import('./PostingRow').then((module) => ({ default: module.PostingRow }))
  )
);
const LocalSeoCommonLoader = Loader(
  lazy(() =>
    import('./LocalSeoCommonLoader').then((module) => ({
      default: module.LocalSeoCommonLoader
    }))
  )
);
const UpgradeToAgency = Loader(
  lazy(() =>
    import('../keywordResearch/keywordTracking/UpgradeToAgency').then(
      (module) => ({ default: module.UpgradeToAgency })
    )
  )
);
const ConnectBusinessProfileModal = Loader(
  lazy(() =>
    import('./ConnectBusinessProfileModal').then((module) => ({
      default: module.ConnectBusinessProfileModal
    }))
  )
);
const CreateNewPost = Loader(
  lazy(() =>
    import('./CreateNewPost').then((module) => ({
      default: module.CreateNewPost
    }))
  )
);
const ProfileLimitErrorSnackBar = Loader(
  lazy(() =>
    import('./ProfileLimitErrorSnackBar').then((module) => ({
      default: module.ProfileLimitErrorSnackBar
    }))
  )
);
const NewCommonChromeExtensionModal = Loader(
  lazy(() =>
    import('src/common/NewCommomChromeExtensionModal').then((module) => ({
      default: module.NewCommonChromeExtensionModal
    }))
  )
);

// Default Export
const BuySlotsCommonModal = Loader(
  lazy(() => import('src/common/LocalSeoCommonComponents/BuySlotsCommonModal'))
);
import { BusinessProfileSelector } from './BusinessProfileSelector';
export const Posting = () => {
  const [searchedKeyword, setSearchedKeyword] = useState(''); // default value
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderDirection, setOrderDirection] = useState('asc');
  const [valueToOrderBy, setValueToOrderBy] = useState('');
  const [filteredData, setFilteredData]: any = useState([]);
  const [getMoreLoader, setGetMoreLoader]: any = useState(false);
  const [nextPageToken, setNextPageToken]: any = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [googleAuthText, setGoogleAuth] = useState(null);
  const [openTask, setOpenTask] = useState(false);
  const [creditLoader, setCreditLoader] = useState(true);
  const [openSnackBar, setOpenSnackBar] = useState(null);
  const [isRefreshData, setIsRefreshData] = useState(null);
  const [showBuyLocalSeoSlot, setShowBuyLocalSeoSlot] = useState(null);
  let locationsData =
    useSelector((state: RootState) => state.localSeo.reduxLocationsData) ??
    null;
  let reduxFilteredLocationsData =
    useSelector(
      (state: RootState) => state.localSeo.reduxFilteredLocationsData
    ) ?? null;
  let selectedBusinessName: any =
    useSelector((state: RootState) => state.localSeo.selectedBusinessName) ??
    '';
  let match =
    reduxFilteredLocationsData?.find(
      (location) => location?.title === selectedBusinessName
    ) || null;
  const localStorageSeoId = getLocalSeoId();

  const [selectedAddress, setSelectedAddress]: any = useState('');

  // useEffect to set when redux data arrives
  useEffect(() => {
    if (!reduxFilteredLocationsData || reduxFilteredLocationsData?.length === 0)
      return;

    const refreshMatch = reduxFilteredLocationsData?.find(
      (location) =>
        location?.name === localStorageSeoId && location?.temp !== true
    );

    setSelectedAddress(
      refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    );
  }, [reduxFilteredLocationsData, localStorageSeoId, match]); // run when any of these change

  const dispatch = useDispatch();
  const businessRef = useRef(null);
  let selectedLocationId: any = useSelector(
    (state: RootState) => state.localSeo.selectedLocationId
  );
  const cleanedLocationId = selectedLocationId?.replace('locations/', '');
  let selectedAccountId: any = useSelector(
    (state: RootState) => state.localSeo.selectedAccountId
  );
  let locationsDetailsLoader =
    useSelector((state: RootState) => state.localSeo.locationsDetailsLoader) ??
    null;
  const locationListResponse =
    useSelector((state: RootState) => state.localSeo.locationListResponse) ??
    false;
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isAgency =
    activePlanName === planDetails?.agency ||
    activePlanName === planDetails?.expertPlus ||
    activePlanName === planDetails.enterprise;
  const googleListingTitle: any =
    useSelector((state: RootState) => state.localSeo.googleListingTitle) ??
    null;
  let selectedBusinessAccountId: any = useSelector(
    (state: RootState) => state.localSeo.selectedBusinessAccountId
  );
  const isLocalSeo = isLocalSeoUser();
  const isLocalSeoUnlocked =
    useSelector((state: RootState) => state.localSeo.isLocalSeoUnlocked) ||
    isLocalSeo ||
    false;
  const isAgencyUpgrade =
    useSelector((state: RootState) => state.keywordResearch.isAgencyUpgrade) ??
    false;
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const stripeLoader =
    useSelector((state: RootState) => state.siteAudit.stripeLoader) ?? true;
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  const loaderRedux =
    useSelector((state: RootState) => state.siteAudit.loader) ?? true;
  // Check if the site audit loader is active
  const isFreePlan = activePlanName === planDetails.free;
  const isNoPlanAccount =
    !stripeLoader &&
    !loaderRedux &&
    userDetails?.email &&
    userDetails?.temp == true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);
  const isExpireAccount =
    !stripeLoader &&
    !loaderRedux &&
    !isFreePlan &&
    userDetails?.email &&
    userDetails?.temp !== true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);

  const isNoPlanOrExpire = isNoPlanAccount || isExpireAccount;
  const isPause =
    stripeSubscriptionDetails &&
    stripeSubscriptionDetails?.pause_collection?.behavior;
  const isNotPause =
    stripeSubscriptionDetails &&
    !stripeSubscriptionDetails?.pause_collection?.behavior;
  const isEnterprise = activePlanName === planDetails?.enterprise;
  const { isChromeBrowser } = useBrowserType();
  const { NotAChromeBrowserBanner } = useChromeBrowserBanner();
  const [rows, setRows]: any = useState([]);
  const navigate = useNavigate();
  const locationStoredId = getLocalSeoId();
  const locationStoredBusinessId = getLocalSeoBusinessId();
  const cleanedStoredLocationId = locationStoredId?.replace('locations/', '');
  const getLocalSeoCookieSqsp = getCookie(localseoSignupSqspFlow) ?? null;
  const isLocalSeoSqsp = getLocalSeoCookieSqsp === localSeoSignupSourceSqsp;
  const seoSpaceChannel = new BroadcastChannel('SEO_Space');
  seoSpaceChannel.onmessage = (event) => {
    if (event?.data?.type === 'gbpc_auth_connection') {
      dispatch(setSelectedBusinessAccountId(event?.data?.accountId));
      setGoogleAuth(event.data);
    }
  };
  const shouldShowConnectModal =
    (isAgency || isLocalSeoUnlocked) &&
    (!locationsData || !reduxFilteredLocationsData);

  useEffect(() => {
    const fetchData = async () => {
      if (!locationsData) {
        await getLocationsDetails();
      }
    };

    fetchData();
    getCredits();
  }, []);

  useEffect(() => {
    if (
      googleAuthText?.message &&
      googleAuthText?.success &&
      location.pathname == paths?.businessPosts &&
      selectedBusinessAccountId
    ) {
      dispatch(setIsConnectionFlow(true));
      dispatch(setLocalSeoSection(1));
      navigate(paths?.localChecker);
      // Clear the authentication message after 5 seconds
      setTimeout(() => {
        setGoogleAuth(null);
      }, 5000);
    }
  }, [googleAuthText]);

  useEffect(() => {
    if (googleListingTitle?.taskId === 'scheduleGbpPosts') {
      setOpenTask(true);
      dispatch(setGoogleListingTitle(null));
    }
  }, [googleListingTitle]);

  useEffect(() => {
    if (
      (selectedAccountId && selectedLocationId) ||
      (locationStoredId && locationStoredBusinessId)
    ) {
      getGmpPostList();
    } else if (
      ((!selectedAccountId && !selectedLocationId) ||
        (!locationStoredId && !locationStoredBusinessId)) &&
      isLocalSeoSqsp
    ) {
      getLocationsDetails();
    }
  }, [selectedAccountId, selectedLocationId]);

  useEffect(() => {
    if (isRefreshData) {
      getGmpPostList();
      setIsRefreshData(null);
    }
  }, [isRefreshData]);

  const getGmpPostList = async (isLoadMore = false) => {
    if (isLoadMore) {
      setGetMoreLoader(true);
    } else {
      setLoader(true);
    }
    const locationId = cleanedLocationId ?? cleanedStoredLocationId;
    const accountId = selectedAccountId ?? locationStoredBusinessId;
    const gmpPostListResponse: any = await gmpPostList(
      locationId,
      isLoadMore,
      accountId,
      nextPageToken
    );
    if (gmpPostListResponse?.status === 'success') {
      if (isLoadMore) {
        // Append new posts to existing ones
        setRows((prevRows) => [
          ...prevRows,
          ...gmpPostListResponse?.localPosts
        ]);
        if (!searchedKeyword?.trim()) {
          setFilteredData((prevRows) => [
            ...prevRows,
            ...gmpPostListResponse?.localPosts
          ]);
        } else {
          const filtered = gmpPostListResponse?.localPosts?.filter((item) =>
            item.summary?.toLowerCase().includes(searchedKeyword.toLowerCase())
          );

          setFilteredData((prevRows) => [...prevRows, ...filtered]);
        }
      } else {
        setRows(gmpPostListResponse?.localPosts);
        setFilteredData(gmpPostListResponse?.localPosts);
      }
      setNextPageToken(gmpPostListResponse?.nextPageToken);
    }
    if (isLoadMore) {
      setGetMoreLoader(false);
    } else {
      setLoader(false);
    }
  };

  const textFieldSx = {
    '& .MuiOutlinedInput-root': {
      padding: '10px 14px',
      borderRadius: '6px',
      border: '1px solid var(--color-border)',
      maxHeight: '44px',
      maxWidth: '256px',
      '& fieldset': {
        border: 'none' // remove default outline border
      },
      '&:hover fieldset': {
        border: 'none'
      },
      '&.Mui-focused fieldset': {
        border: 'none'
      }
    },
    '& input': {
      padding: 0 // remove internal input padding
    }
  };

  const headers = ['Post', 'Type', 'Status', 'Date', ' '];

  const columnToDataKeyMap: any = {
    Type: 'topicType',
    Status: 'state',
    Date: 'createTime'
  };

  const handleRequestSort = (property) => {
    const isAsc = valueToOrderBy === property && orderDirection === 'asc';
    setValueToOrderBy(property);
    setOrderDirection(isAsc ? 'desc' : 'asc');
  };

  const sortedData = useMemo(() => {
    return [...rows]?.sort((a, b) => {
      const aValue = a[valueToOrderBy] ?? '';
      const bValue = b[valueToOrderBy] ?? '';

      if (orderDirection === 'asc') {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      }
      return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
    });
  }, [rows, valueToOrderBy, orderDirection]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  useEffect(() => {
    if (!searchedKeyword?.trim()) {
      setFilteredData(sortedData);
    } else {
      const filtered = sortedData.filter((item) =>
        item.summary?.toLowerCase().includes(searchedKeyword.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchedKeyword, sortedData]);

  const handleSearchChange = (e) => {
    const keyword = e.target.value;
    setSearchedKeyword(keyword);
    if (keyword?.trim() === '') {
      // If input is blank, show all sorted data
      setFilteredData(sortedData);
    } else {
      // Otherwise, filter by the summary key
      const filtered = sortedData.filter((item) =>
        item.summary?.toLowerCase().includes(keyword.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const handleToggle = (event) => {
    setAnchorEl(open ? null : event.currentTarget);
  };

  const handleSelect = (locationObj) => {
    setSelectedAddress(locationObj); // store the full object
    dispatch(setSelectedBusinessNameFilter(locationObj?.title));
    dispatch(setSelectedBusinessName(locationObj?.title));
    const matchedName = locationObj?.name || null;
    const matchedAccountId = locationObj?.accountId || null;
    setLocalSeoId(matchedName);
    setLocalSeoBusinessId(matchedAccountId);
    dispatch(setSelectedLocationId(matchedName));
    dispatch(setSelectedAccountId(matchedAccountId));

    setAnchorEl(null);
  };
  const getLocationsDetails = async (isConnecting = false) => {
    dispatch(setLocationsDetailsLoader(true));
    const squareSpaceSiteId = localStorageMethod('get', 'squareSpaceSiteId');
    const payload = {
      isConnecting,
      squareSpaceSiteId: squareSpaceSiteId ? squareSpaceSiteId : null
    };
    const getLocationsResponse: any = await getLocations(payload);
    dispatch(setLocationListResponse(getLocationsResponse));
    if (
      getLocationsResponse?.status == 'success' &&
      getLocationsResponse?.isGBPConnected
    ) {
      const locations = getLocationsResponse?.locations || [];
      // Filter only locations with selected === true
      const selectedLocations =
        locations?.filter(
          (location) => location?.selected === true && location?.temp !== true
        ) || [];

      // Dispatch filtered data to Redux
      dispatch(setReduxFilteredLocationsData(selectedLocations));
      dispatch(setReduxLocationsData(selectedLocations));
      dispatch(setSelectedBusinessName(selectedLocations[0]?.title));
      const locationStorageId = getLocalSeoId();
      const locationStorageBusinessId = getLocalSeoBusinessId();
      dispatch(
        setSelectedLocationId(
          locationStorageId ? locationStorageId : selectedLocations[0]?.name
        )
      );
      dispatch(
        setSelectedAccountId(
          locationStorageBusinessId
            ? locationStorageBusinessId
            : selectedLocations[0]?.accountId
        )
      );
      if (!locationStorageId && !locationStorageBusinessId) {
        setLocalSeoId(selectedLocations[0]?.name);
        setLocalSeoBusinessId(selectedLocations[0]?.accountId);
      }
      // Extract just the title values and dispatch
      const businessNames = locations?.map((loc) => loc?.title).filter(Boolean); // remove null/undefined
      dispatch(setBusinessNamesData(businessNames));
      if (isConnecting) {
        dispatch(setLocalSeoSection(1));
        navigate(paths?.localChecker);
      }
    } else {
      if (isConnecting) {
        dispatch(setLocalSeoSection(1));
        navigate(paths?.localChecker);
      }
    }
    dispatch(setLocationsDetailsLoader(null));
  };
  const open = Boolean(anchorEl);

  const handleSnackBarClose = () => {
    setGoogleAuth(null);
  };

  const breadcrumbs = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        navigate(paths?.otherTools);
      }}
    >
      {localSeoTexts?.localSeo}
    </Typography>,
    <Typography key="2" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {localSeoTexts?.businessPosts}
    </Typography>
  ];

  const breadcrumbsLocalSeoTask = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        navigate(paths?.otherTools);
      }}
    >
      {localSeoTexts?.localSeo}
    </Typography>,
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="2"
      onClick={() => {
        setOpenTask(false);
      }}
    >
      {localSeoTexts?.businessPosts}
    </Typography>,
    <Typography key="3" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {localSeoTexts?.createNewPost}
    </Typography>
  ];

  const getCredits = async () => {
    setCreditLoader(true);
    let getSearchesDetail: any = await getCreditDetails();
    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
    setCreditLoader(false);
  };
  const handleCloseSnackBar = () => {
    dispatch(setIsAgencyUpgrade(false));
  };
  return (
    <>
      <ProfileLimitErrorSnackBar isLimit={openSnackBar} />
      {/* Set the page title using the Helmet component */}
      <Helmet>
        <title>
          {isLocalSeo
            ? `${SEOSpaceLocal} | Business Posts`
            : localSeoTexts.businessPostHelmetText}
        </title>
      </Helmet>
      {isAgencyUpgrade && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={isAgencyUpgrade}
          autoHideDuration={5000}
          onClose={handleCloseSnackBar}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleCloseSnackBar}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {KeywordTrackingAllTexts?.upgradeSuccessMessage}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {googleAuthText?.message && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={googleAuthText?.message}
          autoHideDuration={5000}
          onClose={handleSnackBarClose}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleSnackBarClose}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {googleAuthText?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {!isLocalSeo && NotAChromeBrowserBanner}

      {isChromeBrowser &&
        !isNoPlanOrExpire &&
        !isFreePlan &&
        isNotPause &&
        !isLocalSeo && (
          <>
            <NewCommonChromeExtensionModal />
          </>
        )}
      <Box sx={keywordOverviewCss?.breadcrumbsMainBoxNew}>
        <Box>
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={keywordResearchDashBoardCss?.navigateNextIcon}
              />
            }
            aria-label="breadcrumb"
          >
            {openTask ? breadcrumbsLocalSeoTask : breadcrumbs}
          </Breadcrumbs>
        </Box>
        <Box sx={keywordOverviewCss?.userTutorialBox}>
          <img
            onClick={() => {
              openNewTab(keywordOverviewTexts?.keywordResearchTutorialsLink);
            }}
            src={
              process.env.PUBLIC_URL +
              `/static/images/icons/keyword/book-open-02.svg`
            }
            alt="icon"
          />
          <Typography
            onClick={() => {
              openNewTab(GMBTutorialLinks?.localSeoTutorial);
            }}
            sx={keywordOverviewCss?.userTutorial}
          >
            {localSeoTexts?.tutorialText}
          </Typography>
        </Box>
      </Box>
      {locationsDetailsLoader || creditLoader ? (
        <LocalSeoCommonLoader />
      ) : (
        <>
          {openTask && (isAgency || isLocalSeoUnlocked) ? (
            <CreateNewPost
              setOpenTask={setOpenTask}
              setIsRefreshData={setIsRefreshData}
            />
          ) : (isAgency || isLocalSeoUnlocked) &&
            reduxFilteredLocationsData?.length === 0 &&
            reduxFilteredLocationsData ? (
            <ConnectBusinessProfileModal />
          ) : (isAgency || isLocalSeoUnlocked) && reduxFilteredLocationsData ? (
            <Card
              sx={{
                ...keywordOverviewCss?.card,
                padding: '0px !important',
                marginBottom: '70px'
              }}
            >
              <CardContent
                sx={{
                  paddingBottom: '0px !important',
                  ...keywordOverviewCss?.cardContent
                }}
              >
                <Box
                  sx={
                    (rows && rows?.length > 0) || loader
                      ? LocalSeoAllSx?.postingMainHeadBox
                      : LocalSeoAllSx?.postingMainHeadBoxNoData
                  }
                >
                  <Box>
                    <Typography
                      sx={LocalSeoAllSx?.googleBusinessProfilePostsSx}
                    >
                      {localSeoTexts?.googleBusinessProfilePosts}
                    </Typography>
                    <Typography
                      sx={LocalSeoAllSx?.googleBusinessProfilePostsDescSx}
                    >
                      {(rows && rows?.length > 0) || loader
                        ? localSeoTexts?.googleBusinessProfilePostsDesc
                        : localSeoTexts?.noPostdata}
                    </Typography>
                  </Box>
                  <Box sx={CreateNewPostCss?.postingSearchBox}>
                    {rows && rows?.length > 0 && (
                      <Box>
                        <TextField
                          variant="outlined"
                          placeholder="Search by keyword"
                          fullWidth
                          sx={textFieldSx}
                          value={searchedKeyword}
                          onChange={handleSearchChange}
                        />
                      </Box>
                    )}
                    <Box>
                      {/* Business Name Filter */}
                      <BusinessProfileSelector
                        selectedAddress={selectedAddress}
                        locations={reduxFilteredLocationsData}
                        isEnterprise={isEnterprise}
                        enterpriseLimit={enterpriseDropdownBusinessesLimit}
                        onSelect={handleSelect}
                        onAddProfile={() => {
                          if (locationListResponse?.limitExceeded) {
                            setShowBuyLocalSeoSlot(true);
                          } else {
                            openNewTab(paths?.googleBusiness);
                          }
                        }}
                        onViewAll={() => {
                          navigate(paths?.localSeoBusinessListRoute);
                        }}
                      />
                    </Box>
                    <Button
                      variant="contained"
                      sx={LocalSeoAllSx?.postingCreateNewPost}
                      onClick={() => {
                        dispatch(setGmpListData([]));
                        dispatch(setLocalPostNameId(null));
                        dispatch(setLocalPostStatus(null));
                        dispatch(setUpdatePostLoader(null));
                        setOpenTask(true);
                      }}
                      disabled={selectedAddress?.isDelete === true}
                    >
                      <Typography
                        sx={LocalSeoAllSx?.postingCreateNewPostTextSx}
                      >
                        {localSeoTexts?.createNewPost}
                      </Typography>
                    </Button>
                  </Box>
                </Box>
                {((rows && rows?.length > 0) || loader) && (
                  <>
                    <TableContainer
                      sx={{
                        ...KeywordOverviewTableCss?.tableContainer
                      }}
                      component={Paper}
                    >
                      <Table>
                        <TableHead>
                          <TableRow
                            sx={KeywordOverviewTableCss?.tableHeaderRow}
                          >
                            {headers?.map((headCell, index) => {
                              const dataKey =
                                columnToDataKeyMap[headCell] || headCell;

                              return (
                                <TableCell
                                  key={headCell}
                                  sx={{ minWidth: 150 }}
                                >
                                  {headCell !== ' ' &&
                                  headCell !== headers[0] ? (
                                    <TableSortLabel
                                      sx={
                                        KeywordOverviewTableCss?.tableSortLabel
                                      }
                                      active={valueToOrderBy === dataKey}
                                      direction={
                                        valueToOrderBy === dataKey
                                          ? (orderDirection as 'asc' | 'desc')
                                          : 'asc'
                                      }
                                      onClick={() => handleRequestSort(dataKey)}
                                    >
                                      <Typography
                                        sx={
                                          KeywordOverviewTableCss?.tableHeadText
                                        }
                                      >
                                        {headCell}
                                      </Typography>
                                    </TableSortLabel>
                                  ) : (
                                    <Typography
                                      sx={
                                        KeywordOverviewTableCss?.tableHeadText
                                      }
                                    >
                                      {headCell}
                                    </Typography>
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {loader ? (
                            Array.from({
                              length: Math.max(rows?.length || 3, 3)
                            }).map((_, rowIndex) => (
                              <TableRow key={rowIndex}>
                                {Array.from({ length: 5 }).map(
                                  (_, cellIndex) => (
                                    <TableCell key={cellIndex}>
                                      <Skeleton
                                        variant="rectangular"
                                        animation="wave"
                                        width={
                                          cellIndex === 0
                                            ? 120
                                            : cellIndex === 1
                                            ? 200
                                            : cellIndex === 2
                                            ? 150
                                            : '80%' // Adjust widths accordingly
                                        }
                                        height={20}
                                        sx={{
                                          borderRadius: '100px',
                                          marginTop: '8px',
                                          marginBottom: '8px',
                                          padding: '5px'
                                        }}
                                      />
                                    </TableCell>
                                  )
                                )}
                              </TableRow>
                            ))
                          ) : filteredData?.length == 0 ? (
                            <TableRow>
                              <TableCell
                                colSpan={9}
                                align="center"
                                sx={{ paddingLeft: '5px !important' }}
                              >
                                {' '}
                                {/* Adjust colSpan based on your table column count */}
                                <Box sx={ListDataTableCss?.rowBoxSx}>
                                  <Typography
                                    sx={ListDataTableCss?.noKeywordsLists}
                                  >
                                    {localSeoTexts?.noPostFound}
                                  </Typography>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ) : (
                            (rowsPerPage > 0
                              ? filteredData?.slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                              : filteredData
                            )?.map((row, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <PostingRow
                                    key={index}
                                    row={row}
                                    getGmpPostList={getGmpPostList}
                                    setOpenTask={setOpenTask}
                                    isDelete={selectedAddress?.isDelete}
                                  />
                                </React.Fragment>
                              );
                            })
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {filteredData && filteredData?.length > 0 && (
                      <Box sx={BackLinkAllCss?.paginationBox}>
                        {nextPageToken ? (
                          <Button
                            sx={BackLinkAllCss?.getMoreBacklinksBtn}
                            onClick={() => {
                              getGmpPostList(true);
                            }}
                          >
                            {getMoreLoader ? (
                              <CircularProgress size={24} />
                            ) : (
                              <Typography
                                sx={BackLinkAllCss?.getMoreBacklinksText}
                              >
                                {'Load more'}
                              </Typography>
                            )}
                          </Button>
                        ) : (
                          <Box></Box>
                        )}
                        <TablePagination
                          sx={ListDataTableCss?.pagination}
                          rowsPerPageOptions={[10, 25, 50, 100]}
                          component="div"
                          count={filteredData?.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          SelectProps={{
                            MenuProps: {
                              disableScrollLock: true
                            }
                          }}
                        />
                      </Box>
                    )}
                  </>
                )}
              </CardContent>
            </Card>
          ) : shouldShowConnectModal ? (
            <ConnectBusinessProfileModal />
          ) : !isAgency && !isLocalSeoUnlocked && activePlanName ? (
            <Card sx={{ ...keywordOverviewCss?.card }}>
              <CardContent sx={keywordOverviewCss?.cardContent}>
                <UpgradeToAgency isLocalSeo={true} isPosting={true} />
              </CardContent>
            </Card>
          ) : (
            <>
              <LocalSeoCommonLoader />
            </>
          )}
        </>
      )}
      {showBuyLocalSeoSlot && (
        <BuySlotsCommonModal
          triggerOpen={true}
          onClose={() => setShowBuyLocalSeoSlot(false)}
          isLocalSeo={true}
        />
      )}
    </>
  );
};
